import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'

import { Map } from 'leaflet'
import { GestureHandling } from 'leaflet-gesture-handling'
import { createPinia, PiniaVuePlugin } from 'pinia'
import smoothscroll from 'smoothscroll-polyfill'
// import VueMatomo from 'vue-matomo'
import "./styles/global.css"
import 'vuetify/dist/vuetify.css'

Map.addInitHook('addHandler', 'gestureHandling', GestureHandling)

Vue.use(PiniaVuePlugin);
const pinia = createPinia()

Vue.config.productionTip = false

/**
 * Vuetify 2 setzt aria-expanded auf den rollenlosen <div class="v-expansion-panel">.
 * Das verstößt gegen die axe-Regel aria-allowed-attr. Der v-expansion-panel-header
 * (ein echter Button) trägt aria-expanded selbst korrekt – das Attribut am Panel-Root
 * ist überzählig. Die Direktive entfernt es und hält es per MutationObserver entfernt,
 * auch nachdem Vuetify es beim Auf-/Zuklappen erneut setzt.
 */
Vue.directive('strip-aria-expanded', {
  inserted(el) {
    const strip = () => {
      if (el.hasAttribute('aria-expanded')) el.removeAttribute('aria-expanded');
    };
    strip();
    const observer = new MutationObserver(strip);
    observer.observe(el, { attributes: true, attributeFilter: ['aria-expanded'] });
    el.__stripAriaObserver = observer;
  },
  unbind(el) {
    if (el.__stripAriaObserver) {
      el.__stripAriaObserver.disconnect();
      delete el.__stripAriaObserver;
    }
  },
});

smoothscroll.polyfill();


new Vue({
  vuetify,
  pinia,
  render: h => h(App)
}).$mount('#app')

